module.exports = __webpack_public_path__ + "img/复制到.83358294.svg";